import {Component, OnInit, Optional, SkipSelf, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Params, Router, RouterLink, RouterLinkActive} from '@angular/router';
import {CommonModule} from '@angular/common';
import {BehaviorSubject, filter, map} from 'rxjs';
import {CommunicationService} from '../communication-service/communication.service';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { Ripple, RippleModule } from 'primeng/ripple';
import { AvatarModule } from 'primeng/avatar';
import { StyleClass, StyleClassModule } from 'primeng/styleclass';
import { Drawer } from 'primeng/drawer';


@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive,DrawerModule, ButtonModule, RippleModule, AvatarModule, StyleClassModule],
  templateUrl: './sidebar.component.html'

})

export class SidebarComponent {
  private sidebarData = new BehaviorSubject<any>(null);
  sidebarData$ = this.sidebarData.asObservable();
  protected relativeRoute: ActivatedRoute | null = null;

  ngOnInit(): void {
    this._communicationServie.toggleState$.subscribe((item)=>{
      this.visible=item
    })
  }

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private _communicationServie:CommunicationService) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.getCurrentRouteWithSidebar(this.router.routerState.root)),
      filter(route => !!route.routeConfig?.data?.['sidebar'])
    ).subscribe(route => {
      this.updateRelativeRoute();
      this.updateSidebar(route.routeConfig?.data?.['sidebar'], route.params);
    });
  }

  private getCurrentRouteWithSidebar(route: ActivatedRoute): ActivatedRoute {
    let result: ActivatedRoute | null = null;
    while (route.firstChild) {
      route = route.firstChild;
      if (route.routeConfig?.data?.['sidebar']) {
        result = route;
      }
    }
    return result ?? route;
  }
  private updateRelativeRoute() {
    // TODO: Make this change at route configuration level
    let currentRoute= this.route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    this.relativeRoute = currentRoute.parent;
  }

  private updateSidebar(sidebarConfig: any, routeParams: Params) {
    const processedItems = sidebarConfig.items.map((item: any) => {
      return {
        ...item,
        link: item.link
      };
    });

    this.sidebarData.next({
      ...sidebarConfig,
      items: processedItems
    });

    console.log(this.sidebarData)
  }

  isProjectsRoute(link: string): boolean {
    if (link !== 'projects') return false;
    // Check if the current URL starts with '/projects'
    return this.router.url.startsWith('/projects');
  }

  @ViewChild('drawerRef') drawerRef!: Drawer;

  closeCallback(e:any): void {
      this.drawerRef.close(e);
  }

  visible: boolean = true;
}
